export default __webpack_public_path__ + "static/media/white.5ec09186.jpg";